import { Component } from '@angular/core';
import { LoginLoadComponent } from '../login-load/login-load.component';
import { LoaderComponent } from '@shared/components/loader/loader.component';
import { AuthService } from '@core/services/auth/auth.service';
import { LoginFormComponent } from '../login-form/login-form.component';
import { ForgotPasswordComponent } from '../forgot-password/forgot-password.component';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    LoginLoadComponent,
    LoaderComponent,
    LoginFormComponent,
    ForgotPasswordComponent,
    FormsModule,
],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  isLoading: boolean = true;
  isSetIdpProvider: boolean = false;
  provider: string = '';
  isForgotPassword: boolean = false;
  currentRoute: string = '';
  returnUrl: string = '';

  constructor(
    protected _auth: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private messageService: MessageService
  ) {
    this.currentRoute = this.router.url;
  }

  ngOnInit() {
    // Get the returnUrl from query parameters
    this.route.queryParams.subscribe(params => {
      this.returnUrl = params['returnUrl'] || '/';
    });
    this.checkProvider();
  }

  updateisForgotPassword(flag: boolean) {
    this.isForgotPassword = flag;
  }

  checkProvider = () => {
    this._auth.checkProvider().subscribe({
      next: (data: any) => {
        this.isSetIdpProvider = data.isSetIdpProvider;
        this.provider = data.provider;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
        console.log('Error checking provider:', error);
      },
    });
  };

  // Method to handle post-login redirection
  onLoginSuccess = () => {
    // Navigate to the returnUrl (which may include messageId query params)
    this.router.navigateByUrl(this.returnUrl);
  };
}
